import { deserialize, serialize } from "./encoding";
import { Err, ErrorCode } from "./error";
export class Storage {
    async set(className, key, obj) {
        return this._set(`${className}_${key}`, JSON.stringify(serialize(obj)));
    }
    async get(cl, className, key) {
        const val = await this._get(`${className}_${key}`);
        let data;
        try {
            data = JSON.parse(val);
        }
        catch (e) {
            throw new Err(ErrorCode.ENCODING_ERROR, e.message);
        }
        return deserialize(cl, data);
    }
    async delete(className, key) {
        return this._delete(`${className}_${key}`);
    }
}
//# sourceMappingURL=storage.js.map